/**
 * Gedeelde datum-hulpfuncties voor dashboards.
 */

/**
 * Geeft een leesbare datum terug: 'Vandaag', 'Gisteren' of volledige datum.
 */
export const formatDateDisplay = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const selected = new Date(date);
  selected.setHours(0, 0, 0, 0);

  if (selected.getTime() === today.getTime()) return 'Vandaag';

  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  if (selected.getTime() === yesterday.getTime()) return 'Gisteren';

  return selected.toLocaleDateString('nl-NL', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
};

/**
 * Geeft datum terug als 'YYYY-MM-DD' voor gebruik in <input type="date">.
 */
export const formatDateForInput = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Geeft datum terug als 'YYYY-MM-DD HH:MM:SS' voor gebruik in API-aanroepen.
 */
export const formatDateForApi = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

/**
 * Geeft de huidige datum terug als 'YYYY-MM-DD' (voor max-attribuut van datumpicker).
 */
export const getTodayString = () => formatDateForInput(new Date());
